import { Component } from '@angular/core';

export interface UsefulLink {
  label: string;
  url: string;
}

@Component({
  selector: 'app-link-box',
  templateUrl: './link-box.component.html',
  styleUrls: ['./link-box.component.css']
})
export class LinkBoxComponent {
links: UsefulLink[] = [
    { label: 'API گالری', url: 'https://cdick.ir/api/gallery' },
    { label: 'پنل Plesk', url: 'https://plesk.example.com' },
    { label: 'SQL Server', url: 'https://sql.example.com' }
  ];
}
